import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var ContentElement = /** @class */ (function (_super) {
    __extends(ContentElement, _super);
    function ContentElement(elementFormat, eventMirror, textRotation) {
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this) || this;
        _this._elementFormat = elementFormat;
        _this._eventMirror = eventMirror;
        _this._textRotation = axCoerceString(textRotation);
        return _this;
        //console.warn('[ContentElement] not implemented');
    }
    Object.defineProperty(ContentElement.prototype, "textBlock", {
        get: function () {
            //console.warn('[ContentElement] - get textBlock not implemented');
            return this._textBlock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "textBlockBeginIndex", {
        get: function () {
            console.warn('[ContentElement] - get textBlockBeginIndex not implemented');
            return this._textBlockBeginIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "elementFormat", {
        get: function () {
            //console.warn('[ContentElement] - get elementFormat not implemented');
            return this._elementFormat;
        },
        set: function (value) {
            //console.warn('[ContentElement] - set textRotation not implemented');
            this._elementFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "eventMirror", {
        get: function () {
            //console.warn('[ContentElement] - get eventMirror not implemented');
            return this._eventMirror;
        },
        set: function (value) {
            //console.warn('[ContentElement] - set eventMirror not implemented');
            this._eventMirror = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "groupElement", {
        get: function () {
            //console.warn('[ContentElement] - get groupElement not implemented');
            return this._groupElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "rawText", {
        get: function () {
            //console.warn('[ContentElement] - get rawText not implemented');
            return this._rawText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "text", {
        get: function () {
            //console.warn('[ContentElement] - get text not implemented');
            return this._text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "textRotation", {
        get: function () {
            //console.warn('[ContentElement] - get textRotation not implemented');
            return this._textRotation;
        },
        set: function (value) {
            //console.warn('[ContentElement] - set textRotation not implemented');
            this._textRotation = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    ContentElement.forceNativeConstructor = true;
    ContentElement.forceNativeMethods = true;
    // JS -> AS Bindings
    ContentElement.GRAPHIC_ELEMENT = 65007;
    return ContentElement;
}(ASObject));
export { ContentElement };
